import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-start',
    imports: [RouterLink],
    templateUrl: './start.component.html',
    styleUrl: './start.component.scss'
})
export class RepeatStartComponent {

}
